import { english } from './english'
import { russian } from './russian'
export const dictionary = {
  english: english,
  russian: russian
}
